module.exports = __webpack_public_path__ + "static/media/efs_minsk_map_rail.c1f3a9fe.jpg";